// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"App_mainContainer__1ZtS9","mainContent":"App_mainContent__1W1tC"};